import {
    Card,
    CardBody,
    Col,
    Collapse,
    Container,
    Row,
} from "reactstrap";

import { useState } from "react";
import classnames from "classnames";
import ProcedureManage from "./Procedure/procedureManage";
import StepsManage from "./Step/stepsManage";
import StagesManage from "./Stage/stagesManage";
import ImportJsonButton from "./importJsonButton";
import ExportJsonButton from "./exportJsonButton";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function Landing() {
    const { folderName } = useParams();
    const folderNameSansExt = folderName?.replace(/\.json$/i, "") || "";
    const [openIndex, setOpenIndex] = useState(null);
    // Sous-domaine situé juste avant ".iximanager" (ex : "ixiverse" ou "cstb")
    const qrText = window.location.hostname.match(/([^.]+)\.iximanager\./i)?.[1] || "";
    const navigate = useNavigate();

    const toggleAccordion = (index) => {
        // Si aucun accordéon n'est ouvert, scroll immédiatement après ouverture
        if (openIndex === null && index !== null) {
            setTimeout(() => {
                const anchor = document.getElementById(anchorIds[index]);
                if (anchor) anchor.scrollIntoView({ behavior: "smooth" });
            }, 200);
        }
        setOpenIndex(openIndex === index ? null : index);
    };

    const accordions = [
        {
            title: (
                <span className="text-tertiary fs-3" id="1" style={{ marginTop: "-90px", paddingTop: "80px", display: "block" }}>
                    <i className="mdi mdi-archive align-middle text-secondary"> </i>
                    Ressources
                </span>
            ),
            content: (
                <>
                    <div className="row">
                        <div className="col-md-6">
                            <h1 className="text-primary"><i className="mdi mdi-arrow-decision me-2"></i>Le standard iXi</h1>
                            <h3 className="text-secondary">1<sup>er</sup> standard XR open source</h3>
                            <p>Le <b>standard iXi</b> définit la structure des procédures et formations XR créées avec iXiMAKER.<br />
                                En utilisant les <b>formats ouverts</b> tels que le JSON, GTLF, OGG et PNG, les contenus iXi sont <b>exploitables librement</b>.</p>
                            <h4 className="text-secondary"><i className="mdi mdi-unity me-2"></i>Code source C#</h4>
                            <p>Pour développer vos propres applications, les adapter à vos besoins et garantir la pérennité de vos contenus,
                                le standard iXi est open-source, sous licence MPL 2.0, et disponible sur <a href="https://github.com/iXiVERSE" target="_blank">Github/iXiVERSE</a>.</p>
                            <h4 className="text-secondary"><i className="mdi mdi-crown-outline me-2"></i>Liberté, pérennité, souverainetée</h4>
                            <p>Le standard iXi garantit une <b>interopérabilité native</b> avec :
                                <ul>
                                    <li>L'ensemble des modèles d'IA (Compréhension, Traductions, Analyses, etc.),</li>
                                    <li>Les applications exploitant le standard (Réalité augmentée, 3D, 2D, )</li>
                                    <li>Les LMS et logiciels de GMAO</li>
                                </ul>
                            </p>
                        </div>
                        <div className="col-md-6">
                            <h1>&nbsp;</h1>
                            <h3 className="text-secondary">Structure</h3>
                            <p>Il est essentiel de comprendre la structure des contenus XR créés avec iXiMAKER pro :<br />
                                <ul>
                                    <li><i className="mdi mdi-account-edit-outline text-primary me-1"></i>Chaque Créateur crée ses propres référentiels</li>
                                    <li><i className="mdi mdi-folder-multiple-outline text-primary me-1"></i>Chaque référentiel contient les différentes "variantes"* d'une procédure.</li>
                                    <li><i className="bx bx-wrench text-primary me-1"></i>Chaque procédure <u>peut</u> contenir sa formation.<br /><i>(une formation ne peut exister sans sa procédure)</i></li>
                                </ul>
                                👉 Les procédures (avec leur formation si exitante) sont librement échangeables par simple import-export des archives zip.
                            </p>
                            <p>*Les référentiels permettent d'organiser les contenus en les regroupant sous un même sujet (ex : MaMachineXYZ), puis sous une variante.<br />
                                Les variantes peuvent être de nature différentes (Langue, version de document, sauvegarde, etc.). <br />
                                ⚠️ <b>Néanmoins, seules les variantes linguistiques sont prises en charge par le standard iXi, lors de la lecture des contenus</b> (ex : MaMachineXYZ_FR).<br />
                            </p>
                        </div>
                        <div className="col-md-12">
                            <hr className="text-primary" />
                            <p className="text-center fs-5">Le standard iXi permet de <b>spatialiser</b> des informations complexes <b>au milimètre près</b> sur un modèles 3D <b>en environnement réel ou simulé</b>.
                            </p>
                            <hr className="text-primary" />
                        </div>
                    </div>
                </> /*<StagesManage />,*/
            )
        },
        {
            title: (
                <>
                    <span
                        id="2"
                        style={{ display: "block", position: "relative", top: "-100px", height: "1px", pointerEvents: "none" }}
                    />
                    <span className="text-tertiary fs-3">
                        <i className="mdi mdi-movie-open align-middle text-secondary"> </i>
                        Vidéothèque
                    </span>
                </>
            ),
            content: (
                <>
                    <div alt='video' className="col-md-12 d-flex justify-content-center row g-3">
                        <div className="col-md-6 d-flex justify-content-center align-items-center g-3">
                            <iframe width="560" height="315"
                                src="https://www.youtube.com/embed/2m-xAtrbRns?si=fBkK_dZZHWnWLYpy"
                                title="iXiWORK" frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                                className="rounded border border-3 border-primary">
                            </iframe>
                        </div>
                        <div className="col-md-6 d-flex justify-content-center align-items-center g-3">
                            <iframe width="560" height="315"
                                src="https://www.youtube.com/embed/C_xQDjguzA8?si=ifQRnpjkoOYkfKBR"
                                title="iXiWORK" frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                                className="rounded border border-3 border-primary">
                            </iframe>
                        </div>
                    </div>
                </> /*<StagesManage />,*/
            )
        },
        {
            title: (
                <>
                    <span
                        id="3"
                        style={{ display: "block", position: "relative", top: "-100px", height: "1px", pointerEvents: "none" }}
                    />
                    <span className="text-tertiary fs-3">
                        <i className="mdi mdi mdi-help-circle align-middle text-secondary"> </i>
                        Aide & Documentation
                    </span>
                </>
            ),
            content: (
                <>
                    <h1 className="text-primary">
                        <i className="mdi mdi-shoe-print"></i>
                        Premiers pas
                    </h1>
                    <h4 className="text-secondary"><i className="mdi mdi-numeric-1-circle fs-3"></i> La création de contenus </h4>
                    <h4 className="text-secondary"><i className="mdi mdi-numeric-2-circle fs-3"></i> La spatialisation XR</h4>
                    <h4 className="text-secondary"><i className="mdi mdi-numeric-3-circle fs-3"></i> La Publication</h4>
                </> /*<StagesManage />,*/
            )
        },
        {
            title: (
                <>
                    <span
                        id="4"
                        style={{ display: "block", position: "relative", top: "-100px", height: "1px", pointerEvents: "none" }}
                    />
                    <span className="text-tertiary fs-3">
                        <i className="mdi mdi-qrcode align-middle text-secondary"> </i>
                        QR-code
                    </span>
                </>
            ),
            content: (
                <>
                    <div className="row justify-content-center">
                        <div className="col-md-12 d-flex justify-content-center">
                            {qrText && (
                                <img
                                    src={`https://quickchart.io/qr?text=${encodeURIComponent(qrText)}&size=250`}
                                    alt="QR-code"
                                    className="rounded border border-3 border-primary p-2"
                                />
                            )}
                        </div>
                    </div>
                </>
            )
        },
    ];

    // Ajoute la logique de scroll dans onExited
    const anchorIds = ["1", "2", "3", "4"];

    return (
        <div>
            <img src="/ixiverse_banner.jpg" alt="ixiverse banner" className="img-fluid w-100 mb-0" style={{ objectFit: 'cover' }} />
            <div className="page-content mt-0 pt-3">
                <div className="container card shadow-lg p-4 position-relative">
                    <div className="col-md-12 d-flex justify-content-center">
                    </div>
                    <img src="/iXiVERSE-LOGO-DrkNoBG.png" alt="iXiMAKER Logo" className="mx-auto d-block mb-0 mt-0" style={{ maxHeight: '150px' }} />
                    <h1 className="text-tertiary text-center">iXiMAKER pro</h1>
                    <h2 className="text-primary mb-3 text-center">Éditeur de contenus XR</h2>
                    <h3 className="text-secondary text-center">Créez, modifiez, publiez et téléchargez<br /><u><b>vos</b></u> procédures + <u><b>vos</b></u> formations.</h3>
                    <div className="col-md-12 mb-3 mt-3">
                        <div className="d-flex justify-content-center align-items-center gap-4">
                            <button className="btn btn-lg btn-tertiary mx-4 px-5 py-3" onClick={() => navigate("/ixivariant")}>
                                <i className="mdi mdi-folder-outline align-middle fs-4 me-2"></i> Référentiels
                            </button>
                        </div>
                    </div>
                    {/*<div className="col-md-12 d-flex justify-content-center">
                <p className="col-md-6 border border-primary rounded text-center small p-2">Pour traduire une procédure, <b>exportez</b> son contenu au format JSON.<br />
                    Faites-le traduire par votre IA préférée, puis <b>importez-le</b>.
                </p>
            </div>*/}
                </div>
                <Container fluid={true}>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <div className="accordion" id="accordion">
                                        {accordions.map((item, index) => (
                                            <div className="accordion-item" key={index}>
                                                <h2 className="accordion-header">
                                                    <button
                                                        className={classnames(
                                                            "accordion-button",
                                                            "fw-medium",
                                                            { collapsed: openIndex !== index }
                                                        )}
                                                        type="button"
                                                        onClick={() => toggleAccordion(index)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        {item.title}
                                                    </button>
                                                </h2>
                                                <Collapse
                                                    isOpen={openIndex === index}
                                                    className="accordion-collapse"
                                                    onExited={() => {
                                                        // Quand la fermeture est terminée, on scroll vers la nouvelle section ouverte
                                                        if (openIndex !== null && anchorIds[openIndex]) {
                                                            const anchor = document.getElementById(anchorIds[openIndex]);
                                                            if (anchor) anchor.scrollIntoView({ behavior: "smooth" });
                                                        }
                                                    }}
                                                >
                                                    <div className="accordion-body">
                                                        {item.content}
                                                    </div>
                                                </Collapse>
                                            </div>
                                        ))}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default Landing;

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license